import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import CandidateProvider from "./context/candidate/store";
// MSAL imports
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { msalConfig } from "./config/authConfig";
import { clearSharedSession, restoreSharedSession } from "./config/sharedSession";

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}
// Una pestaña nueva hereda el usuario de la sesión ya iniciada en otra.
restoreSharedSession(accounts.length > 0);

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
  if (event.eventType === EventType.LOGOUT_SUCCESS) {
    clearSharedSession();
  }
});

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <CandidateProvider>
      <App pca={msalInstance} />
    </CandidateProvider>
  </React.StrictMode>
);
